export default {
  initialized: false,
  loading: false,
  user: {},
};
